import * as Sentry from '@sentry/react';
import { Button, Callout } from './primitives';

/**
 * Root-level error boundary (#499). Wraps @sentry/react's ErrorBoundary so
 * unhandled render errors are reported to Sentry (when configured — see
 * src/sentry.ts, a no-op without VITE_SENTRY_DSN) and shown with a minimal
 * fallback consistent with the existing Leitmotif primitives.
 *
 * There was no existing app-level error boundary to wrap, so this adds one
 * at the root (see main.tsx).
 */
function ErrorFallback() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '64px 24px' }}>
      <div style={{ maxWidth: 480, width: '100%' }}>
        <Callout intent="danger" title="Something went wrong">
          <p style={{ margin: '0 0 12px' }}>
            An unexpected error occurred. Reloading the page usually resolves this.
          </p>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        </Callout>
      </div>
    </div>
  );
}

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

export function SentryErrorBoundary({ children }: SentryErrorBoundaryProps) {
  return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
}
